import { css, Interpolation, Theme } from '@emotion/react'

export const wrapper: Interpolation<Theme> = css`
  display: flex;
  flex-direction: column;
  gap: 15px;
`

export const item: Interpolation<Theme> = (theme) => css`
  display: flex;
  flex-direction: column;
  gap: 15px;

  padding: 12px;
  background: ${theme.backgrounds.backgroundFour};
  border: 1px solid ${theme.backgrounds.backgroundOne};
  box-shadow: ${theme.boxShadows.small};
  border-radius: 14px;
`

export const itemHeader: Interpolation<Theme> = css`
  display: flex;
  justify-content: space-between;
  align-items: start;
`

export const checkbox: Interpolation<Theme> = (theme) => css`
  margin-left: 0;

  .MuiTypography-root {
    font-weight: 400;
    font-size: 16px;
    line-height: 36px;
    color: ${theme.typographyColors.typographyThree};
    margin-left: 8px;
    user-select: none;
  }
`

export const empty: Interpolation<Theme> = (theme) => css`
  color: ${theme.typographyColors.typographyThree};
`

export const pointsWrapper: Interpolation<Theme> = (theme) => css`
  font-weight: 400;
  font-size: 16px;
  line-height: 36px;
  color: ${theme.typographyColors.typographyThree};
  display: flex;
  align-items: start;
`

export const pointsInput: Interpolation<Theme> = css`
  width: 130px;
  margin-right: 8px;

  .MuiFormHelperText-root {
    margin-top: 2px;
  }
`

export const removeButton: Interpolation<Theme> = css`
  &.MuiButtonBase-root {
    height: 36px;
    width: 36px;
    min-width: 36px;
    padding: 0;

    svg {
      height: 20px;
      width: 20px;
    }
  }
`
